import React, { useState } from "react"
import {ChevronDown, HelpCircle} from 'lucide-react'

const faqs = [
  {
    id: 1,
    question: "За сколько времени нужно бронировать ваши услуги?",
    answer: "Рекомендую бронировать за 1-2 месяца для свадеб и крупных мероприятий, особенно в пиковый сезон (май-октябрь). Для небольших событий обычно достаточно 2-4 недель. Однако иногда могу принять и срочные заказы — просто свяжитесь со мной!"
  },
  {
    id: 2,
    question: "Что входит в ваши пакеты ведения?",
    answer: "Все пакеты включают предварительную консультацию, координацию тайминга, профессиональное ведение мероприятия, работу с микрофоном и звуком, а также обратную связь после события. Конкретные включения зависят от типа мероприятия и подробно описаны в каждом пакете. Индивидуальные пакеты можно адаптировать под ваши потребности."
  },
  {
    id: 3,
    question: "Вы работаете за пределами Москвы?",
    answer: "Абсолютно! Я доступна для мероприятий по всей России и за рубежом. Для мероприятий за пределами Москвы применяются транспортные расходы, которые обычно включают транспорт, проживание и суточные. Это обсуждается во время консультации и добавляется в индивидуальный расчёт."
  },
  {
    id: 4,
    question: "Можете ли вы помочь с планированием мероприятия, а не только с ведением?",
    answer: "Хотя моя основная специализация — ведение, я могу порекомендовать проверенных подрядчиков и дать советы по программе и таймингу мероприятия. Я тесно сотрудничаю с вашим организатором или координатором для обеспечения безупречного проведения. Для комплексных услуг планирования могу связать вас с опытными организаторами из моей сети."
  },
  {
    id: 5,
    question: "Что происходит, если мне нужно перенести мероприятие?",
    answer: "Я понимаю, что обстоятельства меняются. Если вам нужно перенести дату, пожалуйста, уведомите меня как можно скорее. Если новая дата доступна, мы можем перенести бронирование без штрафа. Политика отмены зависит от пакета и прописана в договоре. Депозиты не возвращаются, но могут быть применены к перенесённой дате в течение 12 месяцев."
  },
  {
    id: 6,
    question: "У вас есть запасные планы на случай форс-мажора?",
    answer: "Да! Профессиональная готовность — это ключ. У меня всегда есть резервное оборудование (микрофоны, заметки и т.д.) и сеть проверенных запасных ведущих на крайне редкий случай чрезвычайной ситуации. Я никогда не пропускала мероприятие за свою 5+ летнюю карьеру, но ваше спокойствие важно для меня."
  },
  {
    id: 7,
    question: "Как вы работаете с многоязычными мероприятиями?",
    answer: "Я опытна в ведении мероприятий для разнообразной аудитории. Свободно владею русским и французским языком, могу работать с переводчиками для других языков и координировать многоязычные сегменты. Многие корпоративные и культурные мероприятия выигрывают от такого инклюзивного подхода."
  },
  {
    id: 8,
    question: "Какая информация вам нужна от меня перед мероприятием?",
    answer: "Мне понадобятся детали мероприятия, включая дату, время, место проведения, ожидаемое количество гостей, расписание/тайминг события, любые особые традиции или обычаи, имена и произношение для представлений, а также ваше видение/цели мероприятия. Мы подробно обсудим всё это во время консультации."
  },
  {
    id: 9,
    question: "Можете ли вы учесть особые пожелания или уникальные форматы мероприятий?",
    answer: "Определённо! Каждое мероприятие уникально, и я люблю творческие вызовы. Будь то тематическая вечеринка, культурная церемония, виртуальное/гибридное мероприятие или что-то совершенно иное, мы можем обсудить, как это реализовать. Индивидуальные пакеты разработаны именно для таких ситуаций."
  },
  {
    id: 10,
    question: "Как работает оплата?",
    answer: "Для подтверждения даты требуется депозит 50%, остаток оплачивается за 2 недели до мероприятия. Принимаю банковские переводы, кредитные карты и платёжные приложения. Подробные условия оплаты включены в договор об услугах. Для крупных мероприятий могут быть организованы планы оплаты."
  }
]

function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null)

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? null : id)
  }

  return (
    <section id="faq" className="py-20 bg-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-pink-300/20 border border-pink-300/30 rounded-full mb-4">
            <HelpCircle className="w-8 h-8 text-pink-300" />
          </div>
          <h2 className="text-4xl font-bold text-white mb-4">Часто задаваемые вопросы</h2>
          <p className="text-lg text-gray-300">
            Есть вопросы? Вот ответы на самые распространённые запросы, которые я получаю от клиентов.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-gray-900 border border-pink-300/20 rounded-2xl shadow-md shadow-pink-300/10 overflow-hidden hover:shadow-lg hover:shadow-pink-300/20 transition"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-pink-300/5 transition"
              >
                <span className="font-semibold text-white pr-4">{faq.question}</span>
                <ChevronDown
                  className={`w-6 h-6 text-pink-300 flex-shrink-0 transition-transform ${
                    openId === faq.id ? "transform rotate-180" : ""
                  }`}
                />
              </button>
              
              {openId === faq.id && (
                <div className="px-6 pb-5">
                  <div className="pt-2 border-t border-pink-300/20">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Still Have Questions CTA */}
        <div className="mt-12 text-center bg-gradient-to-br from-pink-300/10 to-pink-400/10 border border-pink-300/30 rounded-3xl p-8">
          <h3 className="text-2xl font-bold text-white mb-3">Остались вопросы?</h3>
          <p className="text-gray-300 mb-6">
            Не стесняйтесь обращаться! Я с радостью отвечу на любые конкретные вопросы о вашем мероприятии.
          </p>
          <button
            onClick={() => {
              const contactSection = document.getElementById("contact")
              contactSection?.scrollIntoView({ behavior: "smooth" })
            }}
            className="bg-pink-300 text-black px-8 py-3 rounded-lg font-semibold hover:bg-pink-400 transition shadow-lg shadow-pink-300/20 hover:shadow-pink-300/40"
          >
            Связаться со мной
          </button>
        </div>
      </div>
    </section>
  )
}

export default FAQ
